<template>
  <h2 class="pb-2 border-bottom">Tipos de terapia de reposição hormonal (TRH) que podemos oferecer</h2>
  <h5>Para Mulheres</h5>
  <ul>
    <li>Terapia com Estrogênio e Progesterona – Trata sintomas da menopausa (ondas de calor, mudanças de humor, prevenção da osteoporose)</li>
    <li>Terapia com Hormônios Bioidênticos (BHRT) – Hormônios naturais à base de plantas para tratamento personalizado</li>
    <li>Terapia com Testosterona para Mulheres – Aumenta a libido, energia e tônus muscular</li>
    <li>Terapia com Hormônio da Tireoide – Trata hipotireoidismo e problemas metabólicos</li>
  </ul>

  <h5>Para Homens</h5>
  <ul>
    <li>Terapia de Reposição de Testosterona (TRT) – Injeções, cremes ou pellets para baixa testosterona</li>
    <li>Terapia com DHEA – Suporta a função adrenal, crescimento muscular e equilíbrio do humor</li>
    <li>Otimização da Tireoide – Aborda fadiga, ganho de peso e baixo metabolismo</li>
  </ul>

  <h5>Para Ambos Homens e Mulheres</h5>
  <ul>
    <li>Terapia com Peptídeos – Peptídeos do hormônio do crescimento (por exemplo, Sermorelina, Ipamorelina) para anti-envelhecimento, recuperação muscular e perda de gordura</li>
    <li>Suporte Adrenal e Cortisol – Ajuda com estresse crônico, fadiga e desequilíbrios hormonais</li>
  </ul>

  <h2 class="pb-2 border-bottom">Opções de Tratamento e Métodos de Administração</h2>
  <ul>
    <li>Injeções – Injeções semanais ou quinzenais de testosterona, estrogênio ou peptídeos</li>
    <li>Terapia com Pellets – Pellets hormonais de longa duração inseridos sob a pele (3-6 meses)</li>
    <li>Cremes/Géis Tópicos – Absorvidos pela pele, convenientes para uso diário</li>
    <li>Medicamentos Orais – Disponíveis para alguns tipos de hormônios, mas menos comuns devido ao metabolismo hepático</li>
  </ul>

  <h2 class="pb-2 border-bottom">Processo de Diagnóstico e Monitoramento</h2>
  <p>Para garantir um tratamento seguro e personalizado, ofereça:</p>
  <ul>
    <li>Painéis sanguíneos abrangentes (níveis hormonais, tireoide, marcadores metabólicos)</li>
    <li>Consulta inicial e planejamento do tratamento</li>
    <li>Testes laboratoriais contínuos e ajustes de dosagem</li>
    <li>Acompanhamentos por telemedicina para monitoramento</li>
  </ul>
</template>

<script>
export default {
  name: 'HormoneReplacementContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
